<template>
  <div
    v-if="options"
    class="koc-partial koc-filter-select-partial"
  >
    <div class="koc-dropdown">
      <div class="koc-input-content">
        <input
          :placeholder="placeholder"
          :value="
            state.selected
              ? state.selected.name || state.selected.label
              : state.filter
          "
          class="koc-input"
          :class="{'koc-permanent-label' : permanentLabel}"
          type="text"
          @blur="exit()"
          @focus="state.optionsShown = true; focus()"
          @keyup="filter($event)"
        >
        <label class="koc-label">{{ label }}</label>
        <font-awesome-icon
          :icon="state.optionsShown ? 'angle-up' : 'angle-down'"
          class="koc-dropdown-caret koc-title-2"
          @click="state.optionsShown = !state.optionsShown"
        />
      </div>
      <div
        v-show="state.optionsShown"
        class="koc-dropdown-content"
      >
        <div
          v-for="(option, index) in state.filtered"
          :key="index"
          class="koc-dropdown-item"
          @mousedown="select(option)"
        >
          {{ option.name || option.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./filter.js"></script>
<style lang="scss" scoped src="./filter.scss"></style>
